//This file provides the code for the todos page of the website.

import {loadTodos, createTodo} from './todos-functions';
import {renderTodos} from './todos-views';
import {updateFilters} from './todos-filters';
import {addFooter} from './footer';
import {addMenu} from './sliding-menu';
import {loadHeaderHTML} from './head-html-getter';

//Add the site footer to this page.
addFooter();

//Add the initially-hidden sliding menu to the page.
addMenu();

//Add the HTML to the page header.
loadHeaderHTML();

//Do initial page load.
renderTodos();

//Add function to filter based on text box input after search
//form is submitted.
document.querySelector('#search-form').addEventListener('submit', 
    (e) => {
    //Cancel form's default behavior.
    e.preventDefault();

    //Hide or show search result banner.
    const newSearchText = e.target.elements.searchText.value.trim();
    const actionBar = document.querySelector("#search-actions");
    const searchLabel = document.querySelector("#message-span");

    if (newSearchText) {
        searchLabel.textContent 
            = "Showing search results for "
            + `"${newSearchText.toLowerCase()}."`
        actionBar.style.display = 'block';
    } else {
        actionBar.style.display = 'none';
    }

    //Update display of todos.
    updateFilters({
        searchText: newSearchText
    });
    renderTodos();
});

//Add handler to button that clears searh text.
document.querySelector("#clear-search").addEventListener("click",
    () => {
    //Hide search result banner.
    const actionBar = document.querySelector("#search-actions");
    actionBar.style.display = 'none';

    //Clear search box.
    const searchBox = document.querySelector("#search-text"); 
    searchBox.value = '';

    //Update display of todos.
    updateFilters({
        searchText: ''
    });
    renderTodos();
});

//Add function for "hide completed" checkbox.
document.querySelector('#hide-completed')
    .addEventListener('change', (e) => {
        updateFilters({
            hideCompleted: e.target.checked
        });
        renderTodos();
});

//Add form submission function to submit new todos.
document.querySelector('#add-new-form').addEventListener('submit', 
    (e) => {
    //Cancel form's default behavior.
    e.preventDefault();

    //Make sure some text was entered.
    const text = e.target.elements.addNewText.value.trim();
    if (!text) {
        return;
    }

    //Hide search result banner.
    const actionBar = document.querySelector("#search-actions");
    actionBar.style.display = 'none';

    //Clear search box.
    const searchBox = document.querySelector("#search-text"); 
    searchBox.value = '';

    //Clear filters.
    updateFilters({
        searchText: ''
    });

    //Create and save new todo.
    createTodo(text);

    //Reset web page.
    renderTodos();
    e.target.elements.addNewText.value = '';
});

//Add function to window to keep web pages consistant.
window.addEventListener('storage', (e) => {
    //Add delay to make code work with IE.
    setTimeout(() => { 
        if (e.key === 'todos') {
            //Reinitialize page; this will reset local storage.
            loadTodos();

            //Update DOM.
            renderTodos();
        }
    }, 1000);   
});